// extracted by css-extract-rspack-plugin
export default {"cls1":"Unibrow-cls1_4Yx","cls2":"Unibrow-cls2_vCf Unibrow-cls1_4Yx"};